module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aep-root"
  }, [(_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aep-main"
  }, [_c('div', {
    staticClass: "aep-header"
  }, [_c('h2', {
    staticClass: "aep-title"
  }, [_vm._v("All entry points")]), _vm._v(" "), _c('button', {
    staticClass: "aep-new-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('tab-change', 'create-new')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New entry point\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "aep-body"
  }, [_c('div', {
    staticClass: "aep-table-wrap"
  }, [_c('vue-good-table', {
    key: _vm.tableKey,
    attrs: {
      "mode": "remote",
      "styleClass": "vgt-table good-table condensed striped",
      "columns": _vm.columns,
      "rows": _vm.rows,
      "totalRows": _vm.total,
      "pagination-options": {
        enabled: true,
        perPage: _vm.pageSize,
        setCurrentPage: _vm.page
      },
      "search-options": {
        enabled: false
      },
      "row-style-class": _vm.rowStyleClass
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-per-page-change": _vm.onPerPageChange,
      "on-column-filter": _vm.onColumnFilter
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field === 'keyword') ? _c('span', [_c('strong', {
          staticClass: "aep-keyword-text"
        }, [_vm._v(_vm._s(props.row.keyword))])]) : (props.column.field === 'phrases') ? _c('span', [(_vm.getPhrases(props.row).length) ? _vm._l((_vm.getPhrases(props.row)), function(ph) {
          return _c('span', {
            key: ph,
            staticClass: "aep-phrase-badge"
          }, [_vm._v(_vm._s(ph))])
        }) : _c('span', [_vm._v("—")])], 2) : (props.column.field === 'channels') ? _c('span', _vm._l((_vm.getChannels(props.row)), function(ch) {
          return _c('span', {
            key: ch,
            staticClass: "aep-ch-badge",
            class: ("aep-ch-" + ch)
          }, [_vm._v(_vm._s(_vm.chLabel(ch)))])
        }), 0) : (props.column.field === 'journey') ? _c('span', {
          staticClass: "aep-journey-text"
        }, [(props.row.journey || _vm.getJumpStage(props.row)) ? [(props.row.journey) ? _c('span', [_vm._v(_vm._s(props.row.journey))]) : _vm._e(), _vm._v(" "), (props.row.journey && _vm.getJumpStage(props.row)) ? [_vm._v(" → ")] : _vm._e(), _vm._v(" "), (_vm.getJumpStage(props.row)) ? _c('span', [_vm._v(_vm._s(_vm.getJumpStage(props.row)))]) : _vm._e()] : _c('span', [_vm._v("—")])], 2) : (props.column.field === 'created_at') ? _c('span', [_vm._v("\n              " + _vm._s(_vm.formatDate(props.row.created_at)) + "\n            ")]) : (props.column.field === 'created_by') ? _c('span', [_vm._v("\n              " + _vm._s(_vm.formatEmail(props.row.created_by)) + "\n            ")]) : (props.column.field === 'actions') ? _c('span', [(props.row.entry_point_id) ? _c('button', {
          staticClass: "aep-view-btn",
          on: {
            "click": function($event) {
              return _vm.openOutputs(props.row)
            }
          }
        }, [_vm._v("View outputs")]) : (props.row.keyword_id) ? _c('router-link', {
          staticClass: "aep-edit-btn",
          attrs: {
            "to": {
              path: '/NewKeywordsDetails',
              query: {
                keywordId: props.row.keyword_id
              }
            }
          }
        }, [_vm._v("Edit")]) : _vm._e()], 1) : _c('span', {
          staticClass: "aep-cell-text"
        }, [_vm._v(_vm._s(props.formattedRow[props.column.field] || '—'))])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-map-marker",
      "title": "No entry points found",
      "hint": "Try changing the filters, or create one from the Create new tab."
    }
  })], 1)])], 1)])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "aep-slide"
    }
  }, [(_vm.selectedId) ? _c('div', {
    staticClass: "aep-sidebar"
  }, [_c('div', {
    staticClass: "aep-sidebar-header"
  }, [_c('span', {
    staticClass: "aep-sidebar-title"
  }, [_vm._v("Outputs "), _c('strong', [_vm._v(_vm._s(_vm.selectedKeyword))])]), _vm._v(" "), _c('button', {
    staticClass: "aep-sidebar-close",
    on: {
      "click": _vm.closeSidebar
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), (_vm.sidebarLoading) ? _c('div', {
    staticClass: "aep-sidebar-loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading…\n      ")]) : _c('output-sidebar', {
    attrs: {
      "output": _vm.entryPointOutput,
      "show-ready-header": false
    },
    on: {
      "output_copied": _vm.onDashboardOutputCopied,
      "output_downloaded": _vm.onDashboardQrDownloaded
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-d1b42cc0","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/entry-points/all-entry-points/AllEntryPoints.vue
// module id = cA8P
// module chunks = 1